import BigNumber from 'bignumber.js';

import { ZERO } from 'lib/consts';

interface Params {
  value: string;
  exchangeRate?: string | null;
  accuracy?: number;
  accuracyUsd?: number;
  decimals?: string | null;
  fallbackExchangeRates?: { dscPrice: number; usdtPrice: number };
  tokenSymbol?: string;
}

export default function getCurrencyValue({ value, accuracy, accuracyUsd, decimals, exchangeRate, fallbackExchangeRates, tokenSymbol }: Params) {
  const valueCurr = BigNumber(value).div(BigNumber(10 ** Number(decimals || '18')));
  const valueResult = accuracy ? valueCurr.dp(accuracy).toFormat() : valueCurr.toFormat();

  // Determine effective exchange rate - use provided or fallback based on token symbol
  // Handle "0" string from API (truthy but useless)
  let effectiveRate = exchangeRate && parseFloat(exchangeRate) > 0 ? exchangeRate : null;
  if (!effectiveRate && fallbackExchangeRates && tokenSymbol) {
    const sym = tokenSymbol.toUpperCase();
    if (sym === 'USDT' || sym === 'USDC') {
      effectiveRate = fallbackExchangeRates.usdtPrice > 0 ? String(fallbackExchangeRates.usdtPrice) : null;
    } else if (sym === 'NAX' || sym === 'WNAX' || sym === 'DSC' || sym === 'WDSC') {
      effectiveRate = fallbackExchangeRates.dscPrice > 0 ? String(fallbackExchangeRates.dscPrice) : null;
    }
  }

  let usdResult: string | undefined;
  let usdBn = ZERO;

  if (effectiveRate) {
    const exchangeRateBn = new BigNumber(effectiveRate);
    usdBn = valueCurr.times(exchangeRateBn);
    if (accuracyUsd && !usdBn.isEqualTo(0)) {
      const usdBnDp = usdBn.dp(accuracyUsd);
      usdResult = usdBnDp.isEqualTo(0) ? usdBn.precision(accuracyUsd).toFormat() : usdBnDp.toFormat();
    } else {
      usdResult = usdBn.toFormat();
    }
  }

  return { valueStr: valueResult, usd: usdResult, usdBn };
}
